import {UIGameTradeCreationController} from '../../../../shared/scripts/trade/ui_trade_creation/UIGameTradeCreationController'
import {SectionBgView} from '../../../../shared/scripts/ui_canvas_engine/SectionBgView'

export class UIWGameTradeCreationController extends UIGameTradeCreationController {
    protected getContainer(): SectionBgView {
        const canvas = this.uiGameManager.canvasController
        const w = canvas.appW - canvas.chatWidth - canvas.itemSize * 5
        const h = canvas.itemSize * 4 - canvas.margin * 2
        const x = 0
        const y = canvas.appH - h
        return new SectionBgView(x, y, w, h, canvas.app.stage, true)
    }
}
